import { useContext } from "react";
import { useSelector } from "react-redux";
import { ProjectReport, Identifiable } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectReport(report: Boundaries["editProjectReport"]["request"]): void;
}

function useEditProjectReport(report: Identifiable<ProjectReport>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectReportRequestPending(report),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectReportRequestSuccess(report),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectReportRequestFailure(report),
    ),
    editProjectReport: core.editProjectReport,
  };
}

export { useEditProjectReport };
